import React from 'react';
import { Shield, Smartphone, Leaf, Wrench } from 'lucide-react';

const FeatureCards = () => {
  const features = [
    {
      id: 1,
      icon: Shield,
      title: 'Lifetime Warranty',
      subtitle: 'on all phone covers',
      bgColor: 'bg-amber-100',
      iconColor: 'text-amber-700',
      borderColor: 'border-amber-600'
    },
    {
      id: 2,
      icon: Smartphone,
      title: 'Custom Designs',
      subtitle: 'personalized covers',
      bgColor: 'bg-red-100',
      iconColor: 'text-red-700',
      borderColor: 'border-red-600'
    },
    {
      id: 3,
      icon: Leaf,
      title: 'Eco-Friendly',
      subtitle: 'sustainable materials',
      bgColor: 'bg-green-100',
      iconColor: 'text-green-700',
      borderColor: 'border-green-600'
    },
    {
      id: 4,
      icon: Wrench,
      title: 'Premium Accessories',
      subtitle: 'for your device',
      bgColor: 'bg-orange-100',
      iconColor: 'text-orange-700',
      borderColor: 'border-orange-600'
    }
  ];

  return (
    <div className="max-w-[1400px] mx-auto py-12" data-testid="feature-cards">
      {/* Section Header */}
      <div className="text-center mb-10">
        <h2 className="text-3xl font-black text-stone-900 mb-2">
          Why Choose <span className="text-amber-700">Amlaria</span>?
        </h2>
        <p className="text-stone-600">Premium protection meets bohemian luxury</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {features.map((feature) => {
          const IconComponent = feature.icon;
          return (
            <div
              key={feature.id}
              className={`bg-white p-6 shadow-lg hover:shadow-xl transition-all border-l-4 ${feature.borderColor} group hover:-translate-y-1`}
              data-testid={`feature-card-${feature.id}`}
            >
              <div className={`w-14 h-14 ${feature.bgColor} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}>
                <IconComponent className={`h-7 w-7 ${feature.iconColor}`} strokeWidth={2} />
              </div>
              <h3 className="text-lg font-bold text-stone-900 mb-1">
                {feature.title}
              </h3>
              <p className="text-sm text-stone-600">{feature.subtitle}</p>
            </div>
          );
        })}
      </div>

      {/* Bottom Kilim Pattern */}
      <div className="h-2 mt-12"
        style={{
          backgroundImage: `repeating-linear-gradient(90deg, 
            #78350f 0px, #78350f 20px, 
            #dc2626 20px, #dc2626 40px, 
            #f59e0b 40px, #f59e0b 60px)`
        }}
      ></div>
    </div>
  );
};

export default FeatureCards;
